import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { constant } from '@login/resources/constant';
import { FullRecoveryService } from '@login/services/full-recovery.service';
import { SpinnerService } from '@shared/services/spinner.service';
import { AlertService } from '@shared/services/alert.service';

import {
  DOB_INPUT_CONFIG,
  DOB_VALIDATORS,
  EMAIL_INPUT_CONFIG,
  EMAIL_VALIDATORS,
  FIRST_NAME_INPUT_CONFIG,
  FIRST_NAME_VALIDATORS,
  LAST_NAME_INPUT_CONFIG,
  LAST_NAME_VALIDATORS,
} from './full-recovery.constants';

@Component({
  selector: 'app-full-recovery',
  templateUrl: './full-recovery.component.html',
  styleUrls: ['./full-recovery.component.scss'],
})
export class FullRecoveryComponent implements OnInit {
  emailSent = false;

  fullRecoveryForm: UntypedFormGroup;
  emailInputConfig = EMAIL_INPUT_CONFIG;
  firstNameInputConfig = FIRST_NAME_INPUT_CONFIG;
  lastNameInputConfig = LAST_NAME_INPUT_CONFIG;
  dobInputConfig = DOB_INPUT_CONFIG;

  constructor(
    private fullRecoveryService: FullRecoveryService,
    private spinnerService: SpinnerService,
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.fullRecoveryForm = this.fb.group({
      email: ['', EMAIL_VALIDATORS],
      firstName: ['', FIRST_NAME_VALIDATORS],
      lastName: ['', LAST_NAME_VALIDATORS],
      dateOfBirth: ['', DOB_VALIDATORS],
    });

    this.allInputConfigs.forEach(config => {
      config.form = this.fullRecoveryForm;
    });
  }

  onSendEmail() {
    this.spinnerService.start('Loading...');

    const { email, firstName, lastName, dateOfBirth } =
      this.fullRecoveryForm.value;

    this.fullRecoveryService
      .recoverAccount({
        email,
        firstName,
        lastName,
        dateOfBirth: this.browserToHarpDate(dateOfBirth),
      })
      .subscribe(
        (response: any) => {
          this.emailSent = true;
          this.spinnerService.stop();
        },
        (err: any) => {
          const { errorCode, statusText } = err.error;
          const alertMessage = errorCode
            ? statusText
            : constant.ON_SND_EMAIL_CALL_FAILURE;
          this.alertService.setAlert(alertMessage);
          this.spinnerService.stop();
        },
      );
  }

  private browserToHarpDate(value: string) {
    const [year, month, day] = value.split('-');
    return `${month}${day}${year}`;
  }

  get allInputConfigs() {
    return [
      this.emailInputConfig,
      this.firstNameInputConfig,
      this.lastNameInputConfig,
      this.dobInputConfig,
    ];
  }
}
